import { render } from "./App.vue?vue&type=template&id=10122b8e&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=10122b8e&lang=less"

import exportComponent from "/usr1/jenkins/workspace/FrontEnd_Login_20211011x5/H3Yun_Login/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])